import React, { Fragment, useState } from "react";
import { Btn } from "../../../AbstractElements";
// import { NewMessage } from '../../../../../Constant';
import WithDrawalFormModal from "../Withdrawals/WithdrawalFormModal";

const WithdrawalModalButton = ({ btnText, defaultVal,refreshRecord },props) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Btn attrBtn={{ color: "primary", onClick: toggle }}>{btnText}</Btn>
      <WithDrawalFormModal
        modal={modal}
        NewMessage="Add Withdrawal"
        toggle={toggle}
        defaultVal={defaultVal}
        setModal={setModal}
        refreshRecord={refreshRecord}
        
      />
    </Fragment>
  );
};

export default WithdrawalModalButton;
